import { Link } from "react-router-dom";

const TextLink = ({ link = "#", text = "" }) => {
  return (
    <td className="w-full max-w-[100px]">
      <div className="whitespace-nowrap text-center overflow-hidden bg-white font-ubuntuRegular shadow h-[36px] p-1 rounded">
        <Link
          to={link}
          target="_blank"
          className="hover:underline hover:text-primary decoration-primary text-ellipsis"
        >
          {text}
        </Link>
      </div>
    </td>
  );
};

export default TextLink;
